import { useAppDispatch, useAppSelector } from 'app/state'
import { RequestStatus } from 'features/common'
import { Connection, ProviderType } from 'features/connections'
import { useEffect, useMemo } from 'react'
import { accountRequest } from './accountSlice'

export interface AccountSpatialExtensionInfoProps {
  project: string
  dataset: string
  dataProject: string
  cartoDWAccountProject?: string
  spatialExtensionConnection?: Connection
  accountReady: boolean
}

function useAccountSpatialExtensionInfo(publicView = false): AccountSpatialExtensionInfoProps {
  const dispatch = useAppDispatch()
  const account = useAppSelector((state) => state.account.data)
  const accountReady = useAppSelector((state) => state.account.dataStatus === RequestStatus.Fulfilled)
  const connections = useAppSelector((state) => state.connections.myConnections)

  const spatialExtensionConnection: Connection | undefined = useMemo(() => {
    let connection
    connection = connections?.find((connection) => connection.carto_dw)
    if (!connection) {
      connection = connections?.find((connection) => connection.provider_id === ProviderType.BIGQUERY)
    }

    return connection
  }, [connections])

  useEffect(() => {
    if (!accountReady && !publicView) dispatch(accountRequest())
  }, [accountReady, publicView, dispatch])

  const cartoDWAccountProject = useMemo(() => {
    const accountId = account.id
    if (!accountId || !spatialExtensionConnection?.carto_dw) return
    return `carto-dw-${accountId.replace('_', '-')}`
  }, [account, spatialExtensionConnection])

  return {
    project: account.spatial_extension_project,
    dataset: account.id,
    dataProject: account.do_project_id,
    cartoDWAccountProject,
    spatialExtensionConnection,
    accountReady
  }
}

export default useAccountSpatialExtensionInfo
